import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.7, ease: "easeOut" }
    }
  };
  
  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        delay: 0.6, 
        duration: 0.5, 
        type: "spring", 
        stiffness: 200 
      }
    },
    hover: { 
      scale: 1.05,
      boxShadow: "0px 8px 15px rgba(0, 92, 83, 0.4)",
      transition: { 
        duration: 0.3,
        type: "spring",
        stiffness: 400
      }
    },
    tap: { scale: 0.95 }
  };
  
  // Text animation settings
  const textRevealVariants = {
    hidden: { 
      opacity: 0, 
      y: 50,
    },
    visible: i => ({ 
      opacity: 1, 
      y: 0, 
      transition: { 
        delay: i * 0.1,
        duration: 0.8, 
        ease: "easeOut" 
      } 
    })
  };
  
  // Highlight animation
  const highlightVariants = {
    hidden: { opacity: 0, scale: 0.8, filter: "blur(4px)" },
    visible: { 
      opacity: 1, 
      scale: 1, 
      filter: "blur(0px)",
      transition: { 
        delay: 0.3, 
        duration: 0.5, 
        ease: "easeOut" 
      }
    },
    hover: {
      textShadow: "0 0 20px rgba(0, 255, 255, 0.8)", 
      scale: 1.05,
      transition: { duration: 0.3 }
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-overlay">
        <motion.div 
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1 
            className="hero-title"
            variants={itemVariants}
          >
            Experience the {" "}
            <motion.span 
              className="highlight"
              variants={highlightVariants}
              whileHover="hover"
            >
              Switch
            </motion.span>
          </motion.h1>
          
          <motion.h2 
            className="hero-subtitle"
            variants={itemVariants}
          >
            Experience the Convenience!
          </motion.h2>
          
          <motion.div 
            className="hero-description"
            variants={itemVariants}
          >
            <p>We are Switch, leading the charge for change</p>
          </motion.div>
          
          <motion.div 
            className="cta-button"
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
          >
            <button className="download-button">Download App</button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;